import { Routes, Route } from "react-router-dom";
import { useOrganizationContext } from "../ContextProviders/OrganizationContext";
import { RoleComponentGuard } from "../Reuseables/Guards/RoleComponentGuard";
import { Role } from "../../types/enums";
import Home from "../Homepage/Home";
import { Box } from "@mui/material";
import CreateOrganization from "../PrecureAdminPages/CreateOrganization";
import CreateWorkspace from "../PrecureAdminPages/CreateWorkspace";
import InviteUser from "../PrecureAdminPages/InviteUser";
import DashboardView from "../MyProjectsPage/DashboardPage/DashboardView";
import Savings from "../SavingsPage/Savings";
import InventoryProvider from "../InventoryPage/InventoryProvider";
import InventoryPage from "../InventoryPage/InventoryPage";
import ProjectOverview from "../MyProjectsPage/ProjectOverview";
import MyProjects from "../MyProjectsPage/MyProjects";
import SizeCalculators from "../SizeCalculatorsPage";
import ResourcePage from "../ResourcePage";
import NotFound from "../NotFoundPage";
import { SidebarNavItem } from "../Layout/NavSections";
import HomeIcon from "@mui/icons-material/Home";
import CalculateIcon from "@mui/icons-material/Calculate";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AddIcon from "@mui/icons-material/Add";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import TopicIcon from "@mui/icons-material/Topic";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import PaidIcon from '@mui/icons-material/Paid';
import TrainingPage from "../TrainingPage/TrainingPage";
import ProjectWizard from "../ProjectWizardPages/ProjectWizard";
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import { Inventory } from "@mui/icons-material";

export default function AuthenticatedRouter() {
  const { activeWorkspace } = useOrganizationContext();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <RoleComponentGuard
            roles={[
              Role.PrecureAdmin,
              Role.SolutionOwner,
              Role.LocalCoordinator,
              Role.Partner,
            ]}
          >
            <Home />
          </RoleComponentGuard>
        }
      />
      <Route
        path="/create-project"
        element={
          <Box>
            <RoleComponentGuard
              roles={[Role.SolutionOwner, Role.PrecureAdmin, Role.Partner]}
            >
              <ProjectWizard />
            </RoleComponentGuard>
          </Box>
        }
      />

      <Route
        path="/create-organization"
        element={
          <RoleComponentGuard roles={[Role.PrecureAdmin]}>
            <CreateOrganization />
          </RoleComponentGuard>
        }
      />

      {activeWorkspace.workspaceId === activeWorkspace.organizationId && (
        <Route
          path="/create-workspace"
          element={
            <RoleComponentGuard roles={[Role.PrecureAdmin, Role.Partner]}>
              <CreateWorkspace />
            </RoleComponentGuard>
          }
        />
      )}
      <Route
        path="/invite-user"
        element={
          <RoleComponentGuard roles={[Role.PrecureAdmin, Role.Partner]}>
            <InviteUser />
          </RoleComponentGuard>
        }
      />
      <Route
        path="/dashboard/:pc"
        element={
          <RoleComponentGuard
            roles={[
              Role.PrecureAdmin,
              Role.SolutionOwner,
              Role.LocalCoordinator,
              Role.Partner,
            ]}
          >
            <DashboardView />
          </RoleComponentGuard>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RoleComponentGuard
            roles={[
              Role.PrecureAdmin,
              Role.SolutionOwner,
              Role.LocalCoordinator,
              Role.Partner,
            ]}
          >
            <DashboardView hideBackBtn={true} />
          </RoleComponentGuard>
        }
      />
      <Route
        path="/savings"
        element={
          <RoleComponentGuard
            roles={[
              Role.PrecureAdmin, Role.Partner
            ]}
          >
            <Savings />
          </RoleComponentGuard>
        }
      />
      <Route
        path="/training"
        element={
          <RoleComponentGuard roles={[Role.PrecureAdmin]}>
            <TrainingPage />
          </RoleComponentGuard>
        }
      />
      <Route
        path="/inventory"
        element={
          <RoleComponentGuard roles={[Role.PrecureAdmin]}>
            <InventoryProvider><InventoryPage /></InventoryProvider>
          </RoleComponentGuard>
        }
      />
      {activeWorkspace &&
        activeWorkspace.projects?.map((project) => (
          <Route
            key={project.projectCode}
            path={`/myProjects/${project.projectCode}`}
            element={
              <ProjectOverview key={project.projectCode} project={project} />
            }
          />
        ))}
      <Route path="/myProjects" element={<MyProjects />} />
      <Route path="/size-calculators" element={<SizeCalculators />} />
      <Route path="/resources" element={<ResourcePage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

{
  /* 
          
         

           
            <RoleComponentGuard roles={[Role.PrecureAdmin]}>
              <ListItemNav
                to="/training"
                primary={"Training"}
                icon={
                  <IconButton>
                    <Tooltip title={"Training"} placement="right">
                      <FitnessCenterIcon />
                    </Tooltip>
                  </IconButton>
                }
              />
            </RoleComponentGuard> */
}

export const useNavData = (): SidebarNavItem => {
  const { activeWorkspace } = useOrganizationContext();
  return {
    home: [],
    dashboards: [
      {
        title: "Overview",
        roles: [
          Role.LocalCoordinator,
          Role.PrecureAdmin,
          Role.SolutionOwner,
          Role.Partner,
        ],
        route: "/",
        icon: <HomeIcon />,
      },
      {
        title: "Dashboard",
        roles: [
          Role.PrecureAdmin,
          Role.SolutionOwner,
          Role.LocalCoordinator,
          Role.Partner,
        ],
        route: "/dashboard",
        icon: <InsertChartIcon />,
      },
      {
        title: "Savings",
        roles: [Role.PrecureAdmin, Role.Partner],
        route: "/savings",
        icon: <PaidIcon/>,
      }
    ],
    manage: [
      {
        title: "buttons.createProject",
        roles: [Role.PrecureAdmin, Role.SolutionOwner, Role.Partner],
        route: "/create-project",
        icon: <AddIcon />,
      },
      {
        title: "Create an organization",
        roles: [Role.PrecureAdmin],
        route: "/create-organization",
        icon: <CorporateFareIcon />,
      },
      ...(activeWorkspace?.workspaceId === activeWorkspace?.organizationId
        ? [
            {
              title: "buttons.createWorkspace",
              roles: [Role.PrecureAdmin, Role.Partner],
              route: "/create-workspace",
              icon: <WorkspacesIcon />,
            },
          ]
        : []),
      {
        title: "labels.inviteUser",
        roles: [Role.PrecureAdmin, Role.Partner],
        route: "/invite-user",
        icon: <PersonAddAltIcon />,
      },
      {
        title: "buttons.myProjects",
        roles: [
          Role.PrecureAdmin,
          Role.LocalCoordinator,
          Role.SolutionOwner,
          Role.Partner,
        ],
        route: "/myProjects",
        icon: <FolderOpenIcon />,
      },
      {
        title: "Training",
        roles: [Role.PrecureAdmin],
        route: "/training",
        icon: <FitnessCenterIcon />,
      },
      {
        title: "Inventory",
        roles: [Role.PrecureAdmin],
        route: "/inventory",
        icon: <Inventory />,
      },
    ],
    misc: [
      {
        title: "buttons.sizeCalculator",
        roles: [
          Role.PrecureAdmin,
          Role.LocalCoordinator,
          Role.SolutionOwner,
          Role.Partner,
        ],
        route: "/size-calculators",
        icon: <CalculateIcon />,
      },
      {
        title: "buttons.resources",
        roles: [
          Role.PrecureAdmin,
          Role.LocalCoordinator,
          Role.SolutionOwner,
          Role.Partner,
        ],
        route: "/resources",
        icon: <TopicIcon />,
      },
    ],
  };
};
